import { render, staticRenderFns } from "./Thanks_body.vue?vue&type=template&id=27e5c060"
import script from "./Thanks_body.vue?vue&type=script&lang=js"
export * from "./Thanks_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports